// These are local bounds on an OS-stored session, not JWT signature validation.
// The server remains authoritative on reconnect, including revocation checks.
export const canResumeDesktopSession = (token, user, device, now = Date.now()) => {
  try {
    if (!token || !user?.user_id || !device?.device_id) return false;
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(payload));
    return claims.user_id === user.user_id && claims.did === device.device_id
      && claims.role === user.role && Number.isFinite(claims.exp)
      && claims.exp * 1000 > now;
  } catch {
    return false;
  }
};